export default __webpack_public_path__ + "static/media/7.0a36714b.svg";